import { render, staticRenderFns } from "./Zyzytjtwo.vue?vue&type=template&id=54e08556&scoped=true"
import script from "./Zyzytjtwo.vue?vue&type=script&lang=js"
export * from "./Zyzytjtwo.vue?vue&type=script&lang=js"
import style0 from "./Zyzytjtwo.vue?vue&type=style&index=0&id=54e08556&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e08556",
  null
  
)

export default component.exports